import { SegmentedControl } from '@creditornot/cb-segmented-control';
import React from 'react';
import { useIntl } from 'react-intl';
import { Switch, useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import { RouteWhenAuthenticated } from 'common/components';
import { ExperienceEntityType, PageHeader, useExperienceModuleContext } from 'modules/experience-core';
import HistoricalVenueAvailbility from 'modules/historical-venue-availability/HistoricalVenueAvailability';

import VenueAvailabilityStatus from './index';
import { Entity } from './types';

enum VIEW_TYPE {
  CURRENT = 'current',
  HISTORICAL = 'historical',
}

const ViewRouteMapping: Record<VIEW_TYPE, string> = {
  [VIEW_TYPE.CURRENT]: '',
  [VIEW_TYPE.HISTORICAL]: '/historical',
};

const ControlContainer = styled.div`
  display: flex;
  align-self: stretch;
  align-items: center;
`;

export const ExperienceVenueAvailabilityStatus = () => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const { formatMessage } = useIntl();
  const {
    experienceEntity: { experienceEntityObject, experienceEntityType },
  } = useExperienceModuleContext();
  const entityType: Entity['type'] | null =
    experienceEntityType !== ExperienceEntityType.VENUE ? `${experienceEntityType}` : null;
  const entity = {
    type: entityType,
    [experienceEntityType]: experienceEntityObject,
  } as Entity;
  const isEnterpriseOrBrand = entity.type === 'enterprise' || entity.type === 'brand';
  const isHistorical = history.location.pathname.includes('historical');
  const [viewType, setViewType] = React.useState<VIEW_TYPE>(
    isHistorical && isEnterpriseOrBrand ? VIEW_TYPE.HISTORICAL : VIEW_TYPE.CURRENT,
  );

  if (!entity.type) {
    return null;
  }

  const viewToggleOptions: { label: string; value: VIEW_TYPE }[] = [
    {
      label: `${formatMessage({ id: 'venue-availability-status.current' })}`,
      value: VIEW_TYPE.CURRENT,
    },
    ...(isEnterpriseOrBrand
      ? [
          {
            label: formatMessage({ id: 'venue-availability-status.historical' }),
            value: VIEW_TYPE.HISTORICAL,
          },
        ]
      : []),
  ];

  const handleChangeView = (value: VIEW_TYPE) => {
    setViewType(value);
    history.push(`${path}${ViewRouteMapping[value]}`);
  };

  return (
    <>
      <PageHeader enableSelector={false}>
        <ControlContainer>
          {viewToggleOptions.length > 1 && (
            <SegmentedControl options={viewToggleOptions} onChange={handleChangeView} value={viewType} />
          )}
        </ControlContainer>
      </PageHeader>
      <Switch>
        <RouteWhenAuthenticated exact path={`${path}`}>
          <VenueAvailabilityStatus entity={entity} />
        </RouteWhenAuthenticated>
        {isEnterpriseOrBrand && (
          <RouteWhenAuthenticated exact path={`${path}/historical`}>
            <HistoricalVenueAvailbility entity={entity} />
          </RouteWhenAuthenticated>
        )}
      </Switch>
    </>
  );
};
